export default __webpack_public_path__ + "static/media/bg1.5dbec7fb.jpg";